/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Lv_HintInputs */

const cs_property_registry_lv_hint = /** @type {(inputs: Property_Registry_Lv_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plný výpis listu vlastnictví. Čísla se předvyplní z katastru, nebo je zadejte ručně.`)
};

const en_property_registry_lv_hint = /** @type {(inputs: Property_Registry_Lv_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full title-deed extract. Numbers are prefilled from the cadastre, or enter them manually.`)
};

/**
* | output |
* | --- |
* | "Full title-deed extract. Numbers are prefilled from the cadastre, or enter them manually." |
*
* @param {Property_Registry_Lv_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_lv_hint = /** @type {((inputs?: Property_Registry_Lv_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Lv_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_lv_hint(inputs)
	return cs_property_registry_lv_hint(inputs)
});